import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  config: any = {}
  constructor(
    private configService: ConfigService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.getConfig()
  }

  getConfig() {
    this.configService.config().subscribe(
      data => {
        this.config = data
        this.titleService.setTitle('Login | ' + data.nome)
      }, err => {
      }
    )
  }

}
